import "@fontsource-variable/archivo";
import "@fontsource-variable/bricolage-grotesque";
import "@fontsource-variable/spline-sans-mono";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { router } from "./router.js";
import "./styles.css";

/** The one QueryClient — never construct a second (rules/web.md). */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Availability is cached at the edge for 15 minutes anyway; refetching on
      // every window focus would only hammer a scale-to-zero database.
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("#root ontbreekt in index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
